import { createPinia } from 'pinia'
import { useAppStore } from './app'
import { useUserStore } from './user'
import { useMenuStore } from './menu'
import { useDictStore } from './dict'
import { storeToRefs } from 'pinia'
// 创建 pinia 实例
const pinia = createPinia()

// 统一导出 stores
export { pinia, useAppStore, useUserStore, useMenuStore, useDictStore, storeToRefs }

// 初始化函数
export function setupStore(): void {
  const appStore = useAppStore()

  // 初始化系统信息
  // appStore.initSystemInfo()
  // appStore.initRegion()

  // 如果有token，自动刷新用户信息
  // if (userStore.token) {
  //   userStore.refreshUserInfo().catch(() => {
  //     // 如果刷新用户信息失败，可能是token过期，执行登出操作
  //     userStore.logout();
  //   });
  // }
}
